/* eslint-disable react/prop-types */
import {Outlet, Navigate} from 'react-router-dom';

const ProtectedDashboard = ({authorized, defaultDashboard}) => {

    return authorized ? <Outlet/> : <Navigate to={`/dashboard/${defaultDashboard}`} replace/>

}

export default ProtectedDashboard;
